import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-573699ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["placeholder", "readonly"];
const _hoisted_2 = { class: "icon-wrapper" };
const _hoisted_3 = {
    key: 0,
    class: "option-list",
    ref: "list"
};
const _hoisted_4 = { class: "option-type" };
const _hoisted_5 = ["onClick"];
import { computed, ref } from "vue";
import NotificationEllipsis from "src/shared/v-components/ui/NotificationEllipsis.vue";
import { useBuiltRewardSuppliers } from "src/shared/store/reward/supplier/composables";
import { onClickOutside } from "@vueuse/core";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import Strings from "src/shared/Strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierSelector',
    props: {
        rewardSupplierId: {},
        disabled: { type: Boolean }
    },
    emits: ["update:rewardSupplierId"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const searchQuery = ref("");
        const showOptions = ref(false);
        const target = ref(null);
        const input = ref(null);
        onClickOutside(target, () => {
            showOptions.value = false;
        });
        const { rewardSuppliers, primer } = useBuiltRewardSuppliers({
            include_disabled: false,
        });
        const emit = __emit;
        const valueProxy = computed({
            get: () => props.rewardSupplierId,
            set: (value) => emit("update:rewardSupplierId", value),
        });
        const rewardSupplierOptions = computed(() => {
            return rewardSuppliers.value.map((rewardSupplier) => {
                return {
                    displayName: Strings.capitalize(rewardSupplier.name),
                    faceValue: rewardSupplier.getFormattedValue() || rewardSupplier.face_value,
                    value: rewardSupplier.id,
                    displayType: rewardSupplier.getFormattedDisplayType(),
                };
            });
        });
        const filteredOptions = computed(() => {
            return useFuzzySearch(searchQuery, rewardSupplierOptions.value, [
                "displayName",
                "value",
            ]).value.filter((option) => option.displayName !== undefined);
        });
        const groupedOptions = computed(() => {
            return filteredOptions.value.reduce((acc, rewardSupplier) => {
                const displayType = rewardSupplier.displayType || "other";
                if (!acc[displayType]) {
                    acc[displayType] = [];
                }
                acc[displayType].push({
                    displayName: rewardSupplier.displayName,
                    faceValue: rewardSupplier.faceValue,
                    value: rewardSupplier.value,
                });
                return acc;
            }, {});
        });
        const selectedOption = computed(() => {
            return rewardSupplierOptions.value.find((option) => option.value === valueProxy.value);
        });
        const formattedSelectedOption = computed(() => {
            var _a, _b;
            return ((_a = selectedOption.value) === null || _a === void 0 ? void 0 : _a.faceValue)
                ? `${selectedOption.value.displayName} (${selectedOption.value.faceValue})`
                : (_b = selectedOption.value) === null || _b === void 0 ? void 0 : _b.displayName;
        });
        const handleFocus = () => {
            showOptions.value = true;
        };
        const toggleOptions = () => {
            var _a;
            if (!((_a = input.value) === null || _a === void 0 ? void 0 : _a.value)) {
                showOptions.value = !showOptions.value;
            }
        };
        const selectOption = (option) => {
            valueProxy.value = option.value;
            showOptions.value = false;
            searchQuery.value = "";
        };
        const clearSelection = () => {
            var _a;
            valueProxy.value = null;
            searchQuery.value = "";
            showOptions.value = true;
            (_a = input.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(primer).isLoading)
                    ? (_openBlock(), _createBlock(NotificationEllipsis, { key: 0 }))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                    class: "searchable-select",
                    ref_key: "target",
                    ref: target
                }, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: formattedSelectedOption.value || 'Search',
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                        onFocus: handleFocus,
                        readonly: !!selectedOption.value,
                        ref_key: "input",
                        ref: input,
                        class: _normalizeClass({ 'has-value': !!selectedOption.value })
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1), [
                        [_vModelText, searchQuery.value]
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        (selectedOption.value)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "fal fa-times",
                                onClick: clearSelection
                            }))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("i", {
                            class: "fal fa-chevron-down",
                            onClick: _cache[1] || (_cache[1] = ($event) => (toggleOptions()))
                        })
                    ]),
                    (showOptions.value && groupedOptions.value)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedOptions.value, (options, type) => {
                                return (_openBlock(), _createElementBlock("li", { key: type }, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(type), 1 /* TEXT */),
                                    _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: option.value,
                                                onClick: () => selectOption(option)
                                            }, _toDisplayString(option.displayName) + " " + _toDisplayString(option.faceValue ? ` (${option.faceValue})` : ""), 9 /* TEXT, PROPS */, _hoisted_5));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */))
                        : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
